export default __webpack_public_path__ + "static/media/61t.28c893ce.jpg";